import { ItemContainerCreator } from "./item-container-creator";
import { GraphicPanel, FixedDimension, PercentDimension } from "../../../../../web-graphics";

export class PanelCreator extends ItemContainerCreator {
  constructor(commonSettings) {
    super(commonSettings);
  }

  static prepareSettings(settings) {
    settings.location = {
      x: settings.x?.copy() ?? new FixedDimension(0),
      y: settings.y?.copy() ?? new FixedDimension(0)
    };
    settings.size = {
      width: settings.width?.copy() ?? new PercentDimension(1),
      height: settings.height?.copy() ?? new PercentDimension(1)
    };
    settings.parent = {
      ref: settings._parentObject
    };
  }

  static createItems(itemsSettings, viewObjectCreators, panelObject, canvasObject, idGenerator, creator) {
    if (itemsSettings === undefined || !Array.isArray(itemsSettings)) {
      return;
    }
    let calllbackArray = creator.callbacks.get("beforeAddItems");
    calllbackArray.forEach(callback => callback(panelObject, itemsSettings, creator));
    for (let itemIndex = 0; itemIndex < itemsSettings.length; itemIndex++) {
      ItemContainerCreator.createItem(itemsSettings[itemIndex], viewObjectCreators, panelObject, canvasObject, idGenerator, item => {
        panelObject.addItem(item);
      });
    }
  }

  create(settings) {
    let calllbackArray = this.callbacks.get("beforeCreate");
    calllbackArray.forEach(callback => callback(settings, this));
    PanelCreator.prepareSettings(settings);
    const panelObject = new GraphicPanel(settings);
    PanelCreator.createItems(
      settings.items,
      settings._viewObjectCreators,
      panelObject,
      settings._canvasObject,
      settings._idGenerator,
      this
    );
    calllbackArray = this.callbacks.get("afterCreate");
    calllbackArray.forEach(callback => callback(panelObject, settings, this));
    return panelObject;
  }
}
